// const API_URL = "https://auxinstech.com/pos/public/api/";
const API_URL = "https://pos.foodslift.com/backend_inventory/public/api";

const POSTAL_CODE_API_KEY = "ak_mct3xfjnPixcB0WoKgkmGxB0b4hZH";
const POSTAL_CODE_API_URL = "https://api.ideal-postcodes.co.uk/v1/postcodes/";

export { API_URL, POSTAL_CODE_API_KEY, POSTAL_CODE_API_URL };

export const constant = {
  ACCESS_TOKEN: "AccessToken",
  REFRESH_TOKEN: "RefreshToken",
  ACTIVE_STORE: "ActiveStore",
};

// Pusher

export const PUSHER_APP_ID = 2037595;
export const PUSHER_APP_KEY = "28d196be1ae3b33d993f";
export const PUSHER_APP_SECRET = "bc5f44e6a1ae17993434";
export const PUSHER_APP_CLUSTER = "ap2";
export const PUSHER_SCHEME = "https";
